export const LogoMark = ({ className = "h-11 w-11" }) => (
  <img src="/logo-chair.png" alt="" className={`${className} object-contain`} aria-hidden="true" />
);

export const Logo = () => (
  <span className="flex items-center gap-3">
    <LogoMark />
    <span className="leading-tight">
      <span className="block whitespace-nowrap font-serif text-xl font-bold tracking-tight text-espresso">
        Off Our Rockers
      </span>
      <span className="block text-xs font-bold uppercase tracking-[0.22em] text-brand">
        Seniors Care · Calgary
      </span>
    </span>
  </span>
);
